export async function buildImageOnlyPdfFromCanvas(canvas: HTMLCanvasElement, jpegQuality: number = 0.92): Promise<Blob> {
    const jpegBlob = await new Promise<Blob>((resolve, reject) => {
        canvas.toBlob(b => {
            if (!b) {
                reject(new Error('jpeg encode failed'));
                return;
            }
            resolve(b);
        }, 'image/jpeg', jpegQuality);
    });
    const jpegBytes = new Uint8Array(await jpegBlob.arrayBuffer());
    const w = canvas.width;
    const h = canvas.height;
    const pageW = 612;
    const pageH = Math.max(1, Math.round((h / w) * pageW));
    const content = `q\n${pageW} 0 0 ${pageH} 0 0 cm\n/Im0 Do\nQ\n`;

    const encoder = new TextEncoder();
    const chunks: Uint8Array[] = [];
    const offsets: number[] = [0];
    let pos = 0;

    const add = (data: Uint8Array | string) => {
        const bytes = typeof data === 'string' ? encoder.encode(data) : data;
        chunks.push(bytes);
        pos += bytes.length;
    };
    const beginObj = () => {
        offsets.push(pos);
    };

    add('%PDF-1.4\n');
    beginObj();
    add('1 0 obj\n<< /Type /Catalog /Pages 2 0 R >>\nendobj\n');
    beginObj();
    add('2 0 obj\n<< /Type /Pages /Kids [3 0 R] /Count 1 >>\nendobj\n');
    beginObj();
    add(
        `3 0 obj\n<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${pageW} ${pageH}] /Resources << /XObject << /Im0 4 0 R >> >> /Contents 5 0 R >>\nendobj\n`
    );
    beginObj();
    add(
        `4 0 obj\n<< /Type /XObject /Subtype /Image /Width ${w} /Height ${h} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${jpegBytes.length} >>\nstream\n`
    );
    add(jpegBytes);
    add('\nendstream\nendobj\n');
    beginObj();
    add(`5 0 obj\n<< /Length ${content.length} >>\nstream\n${content}\nendstream\nendobj\n`);

    const xrefPos = pos;
    add(`xref\n0 ${offsets.length}\n`);
    add('0000000000 65535 f \n');
    for (let i = 1; i < offsets.length; i++) {
        add(`${offsets[i].toString().padStart(10, '0')} 00000 n \n`);
    }
    add(`trailer\n<< /Size ${offsets.length} /Root 1 0 R >>\nstartxref\n${xrefPos}\n%%EOF`);

    const out = new Uint8Array(pos);
    let o = 0;
    for (let i = 0; i < chunks.length; i++) {
        out.set(chunks[i], o);
        o += chunks[i].length;
    }
    return new Blob([out], { type: 'application/pdf' });
}
